import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
//
import Login from '../pages/auth/LoginPage';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/redux/store';
import { postRefreshToken } from 'src/redux/slices/auth';
import { PATH_PAGE } from 'src/routes/paths';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

// Aqui você define quais permissões cada rota precisa
const routePermissions: Record<string, string[]> = {
  '/dashboard/schedule': ['scheduling'],
  '/dashboard/delivery/orders': ['restaurant'],
  '/dashboard/delivery/dashboard': ['restaurant'],
  '/dashboard/instance': ['assistant'],
  '/dashboard/chats': ['assistant'],
  '/dashboard/contacts': ['assistant'],
  '/dashboard/knowledge-base': ['assistant'],
  '/dashboard/alfred-studio': ['assistantConfig'],
  // adicione as outras rotas que precisar
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const authState = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  // Refresh token
  useEffect(() => {
    if (authState.refreshToken) {
      dispatch(postRefreshToken({ refreshToken: authState.refreshToken }));
    }
  }, [dispatch, authState.refreshToken]);

  // Verifica se o usuário está logado
  if (!authState.accessToken || authState.accessToken.length === 0) {
    if (pathname !== requestedLocation) setRequestedLocation(pathname);
    return <Login />;
  }

  // Verifica permissões para a rota atual
  const requiredRoles = routePermissions[pathname] || [];
  const userRoles: string[] =
    authState.userReturn.modules?.map((m: any) =>
      typeof m === 'string' ? m.toLowerCase() : m.name?.toLowerCase()
    ) || [];

  const hasPermission =
    requiredRoles.length === 0 ||
    requiredRoles.some(role => userRoles.includes(role.toLowerCase()));

  if (!hasPermission) {
    return <Navigate to={PATH_PAGE.page403} />;
  }

  // Redireciona se necessário
  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
